import isEmpty from "lodash.isempty";
import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { RouteProps, useHistory } from "react-router-dom";

import { ErrorSnackbarContext } from "../../App";
import { ORDER_FORM_TYPE } from "../../common/constants";
import { actionFetchOrderCoupons } from "../Coupons/actions";
import { actionReorder } from "./actions";
import Order from "./Order";

interface IReorderProps extends RouteProps {}

/**
 *
 */
function Reorder({ location }: IReorderProps) {
  const { toggleAlerts } = useContext(ErrorSnackbarContext);
  const dispatch = useDispatch();
  const history = useHistory();

  let orderToEdit;

  if (isEmpty(orderToEdit) && location && location.state) {
    // @ts-ignore
    orderToEdit = location?.state.order;
  }

  if (isEmpty(orderToEdit)) {
    return null;
  }

  const initialValues = {
    id: orderToEdit.id,
    tax: orderToEdit.tax,
    type: orderToEdit.type,
    category: orderToEdit.category,
    subtotal: orderToEdit.subTotal,
    grandTotal: orderToEdit.grandTotal,
    receivedAt: orderToEdit.receivedAt,
    address: orderToEdit.address,
    customer: orderToEdit.customer,
    products: orderToEdit.products,
    varietyOrder: orderToEdit.varietyOrder,
    varietyItems: orderToEdit.varietyItems,
    deliveryTotal: orderToEdit.deliveryTotal,
    deliveryCharge: orderToEdit.deliveryCharge,
    paymentSurcharge: orderToEdit.paymentSurcharge,
    distanceSurcharge: orderToEdit.distanceSurcharge,
    paymentMethod: orderToEdit.paymentMethod,
    couponCode: !isEmpty(orderToEdit.discountCodes)
      ? orderToEdit.discountCodes[orderToEdit.discountCodes.length - 1]
      : {},
    extrasSurcharge: orderToEdit.extrasSurcharge,
    bothStoreSurcharge: orderToEdit.bothStoreSurcharge,
    typeSurcharge: orderToEdit.typeSurcharge,
    surchargeTotal: orderToEdit.surchargeTotal,
    discount: orderToEdit.discount,
    varietySurcharge: orderToEdit.varietySurcharge,

    senderAccount: orderToEdit.senderAccount,
    senderAddress: orderToEdit.senderAddress,

    billAccount: orderToEdit.billAccount,
    billAddress: orderToEdit.billAddress,
  };

  function onSubmit(values: any) {
    dispatch(actionReorder(values))
      // @ts-ignore
      .then(
        () => {
          dispatch(actionFetchOrderCoupons());
          toggleAlerts("Successfully re-ordered.");

          history.goBack();
        },
        () => {
          toggleAlerts("Error occurred while re-ordering the order.", true);
        }
      );
  }

  return (
    <Order
      order={orderToEdit}
      onSubmit={onSubmit}
      initialValues={initialValues}
      orderFormType={ORDER_FORM_TYPE.Reorder}
    />
  );
}

export default Reorder;
